import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { defaultInfoBarData } from './defaultInfoBarData'
import dateFormat from 'dateformat'
import AddInfoBarForm from './AddInfoBarForm'
import { addInfobar } from 'app/redux/store/features/infobars'

function toStartOfDay(value) {
    if (value == null) return value
    const d = value instanceof Date ? new Date(value.getTime()) : new Date(value)
    if (isNaN(d.getTime())) return value
    d.setHours(0, 0, 0, 0)
    return d
}

const AddInfoBar = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const todayStart = (() => {
        const d = new Date()
        d.setHours(0, 0, 0, 0)
        return d
    })()
    const todayEnd = (() => {
        const d = new Date()
        d.setDate(d.getDate() + 2000)
        d.setHours(0, 0, 0, 0)
        return d
    })()

    const [InfoBarData] = useState({
        ...defaultInfoBarData,
        dateStart: todayStart,
        dateEnd: todayEnd,
    })
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { loading, error } = useSelector((state) => state.infobars)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)
        if (error) handleError(error)
        else {
            enqueueSnackbar('Info Bar added successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/settings/configuration/info-bar')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onAddInfoBar = useCallback((e) => {
        console.log(e)
        setApiCallInProgress(true)

        const form = new FormData()
        form.append('dateStart', dateFormat(toStartOfDay(InfoBarData.dateStart) ?? InfoBarData.dateStart, 'isoDateTime', true))
        form.append('dateEnd', dateFormat(InfoBarData.dateEnd, 'isoDateTime', true))
        form.append('orderBy', InfoBarData.orderBy)
        form.append('image', InfoBarData.file[0])
        form.append('heading', InfoBarData.heading)
        form.append('subText', InfoBarData.subText)
        form.append('timeText', InfoBarData.timeText)
        form.append('navigationLink', InfoBarData.navigationLink)
        form.append('timeText', InfoBarData.timeText)

        e.preventDefault()
        dispatch(
            addInfobar(form, {
                'Content-Type': 'multipart/form-data',
            })
        )
    }, [])

    return (
        <React.Fragment>
            <AddInfoBarForm InfoBarData={InfoBarData} addInfoBar={onAddInfoBar} />
        </React.Fragment>
    )
}

export default AddInfoBar
